// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SettingsCollectionModel } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection as optimizelyGetSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { CustomerValidationDto } from "@insite/client-framework/Types/ApiModels";

export interface CustomSettingsCollectionModel extends SettingsCollectionModel {
    customSettings: {
        maximumNumberOfAttributesToDisplay: number;
        maximumNumberOfAttributesValuesToDisplay: number;
    };
    categoryPageSettings: {
        smallDefaultCategoryImage: string;
        largeDefaultCategoryImage: string;
        smallDefaultBrandImage: string;
        largeDefaultBrandImage: string;
    };
    contactUsSettings: {
        formName: string;
        firstNameFieldName: string;
        lastNameFieldName: string;
        emailFieldName: string;
        phoneFieldName: string;
        streetFieldName: string;
        cityFieldName: string;
        stateFieldName: string;
        zipFieldName: string;
        countryFieldName: string;
        populateAddressFieldsFromCustomer: string;
    };
    insideSalesSettings: {
        emailAddress: string;
        phoneNumber: string;
    };
    xngSecuritySettings: {
        checkReCaptchaForZohoSubscribeOnClientSide: boolean;
    };
    xngShippingSettings: {
        collectCarrierId: string;
    };
    resourcesAndNewsTopics: {
        name: string;
        description: string;
    }[];
    billToValidation: CustomerValidationDto | null;
    shipToValidation: CustomerValidationDto | null;
    general: {
        addressValidationEnabled: boolean;
    };
}

export function getSettingsCollection(state: ApplicationState): CustomSettingsCollectionModel {
    return optimizelyGetSettingsCollection(state) as CustomSettingsCollectionModel;
}
